import ReactCountryFlag from 'react-country-flag';
import OptionTitle from '../../../../form-dropdown/components/OptionTitle/OptionTitle';
import { generateCompStylers } from '../../../../../../../common/utils/styles';
import css from './PhoneOption.module.scss';
import classNames from 'classnames';

const PhoneOption = ({ defaultProps, opt, searchValue, compStyle }) => {
    const { stylers, classes } = generateCompStylers(compStyle);
    return (
        <div {...defaultProps}>
            <div style={stylers.option || {}} className={classNames(classes.option, css.phoneOption)}>
                <ReactCountryFlag
                    svg
                    countryCode={opt?.country?.replace('-copy', '')}
                    style={{
                        border: '1px solid var(--greyProductHoverColor)',
                        objectFit: 'cover',
                        width: '20px',
                        height: '15px',
                        ...(stylers.optionFlag || {})
                    }}
                />
                <div className={css.optionTitleText}>
                    <OptionTitle compCss={{ optionTitle: css.optionTitleName }} searchValue={searchValue} option={opt} />{' '}
                    <OptionTitle
                        compCss={{ optionTitle: css.optionTitleCode }}
                        searchValue={searchValue}
                        option={{ title: `+${(opt?.phone_code || '').replace('+', '')}` }}
                    />
                </div>
            </div>
        </div>
    );
};
export default PhoneOption;
